import { render, staticRenderFns } from "./UploadField.vue?vue&type=template&id=ca536362&scoped=true&"
import script from "./UploadField.vue?vue&type=script&lang=js&"
export * from "./UploadField.vue?vue&type=script&lang=js&"
import style0 from "./UploadField.vue?vue&type=style&index=0&id=ca536362&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca536362",
  null
  
)

export default component.exports